// @flow

type UnicodeMap = {|
  latin: string,
  latinExt: string,
|};

type Font = {
  name: string,
  locals: Array<string>,
  unicodeRange: Array<$Keys<UnicodeMap>>,
  urls: {
    woff2: string,
    woff: string,
  },
  weight: number,
};

const unicodeMap: UnicodeMap = {
  latin: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
  latinExt: 'U+0100-024F, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF',
};

const generateFontFace = (fonts: Array<Font>): string => fonts.map((font: Font) => font.unicodeRange.map((lang: $Keys<UnicodeMap>) => (`
      @font-face {
        font-display: swap;
        font-family: ${font.name};
        font-style: normal;
        font-weight: ${font.weight};
        src:  ${font.locals.map(localName => `local('${localName}')`).join(',')},
              url(${font.urls.woff2}) format('woff2'),
              url(${font.urls.woff}) format('woff');
        unicode-range: ${unicodeMap[lang]};
      }
    `)).join(' ')).join(' ');

export default generateFontFace;
